import { API } from 'aws-amplify';

export const getProfile = () => {
  return new Promise((resolve, reject) => {
    API.get("API", "/profile", {
      response: false
    })
    .then(response => {
      resolve(response);
    })
    .catch(error => {
      reject(error);
    });
  });
}

export const rateItem = (id, rating, item, unrate) => {
  return new Promise((resolve, reject) => {
    API.post("API", "/profile", {
      response: false,
      body: {
        action: "rating",
        id: id,
        rating: rating,
        item: item,
        unrate: unrate
      }
    }).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    })
  });
}

export const getIndustrySuggestions = (value, language, group) => {
  return new Promise((resolve, reject) => {
    API.get('API', '/lookup', {
      response: false,
      queryStringParameters: {
        type: 'naics',
        keywords: value,
        language: language,
        group: group
      }
    })
    .then(response => {
      resolve(response);
    })
    .catch(error => {
      reject(error);
    });
  });
}

export const getJobSuggestions = (value, language) => {
  return new Promise((resolve, reject) => {
    API.get('API', '/lookup', {
      response: false,
      queryStringParameters: {
        type: 'soc',
        keywords: value,
        language: language
      }
    })
    .then(response => {
      resolve(response);
    })
    .catch(error => {
      reject(error);
    });
  });
}

export const postChat = (values) => {
  return new Promise((resolve, reject) => {
    API.post("API", "/chat", {
      response: false,
      body: values
    }).then(response => {
      
      resolve(response);
    }).catch(error => {
      reject(error);
    })
  });
}

export const postID = (values) => {
  return new Promise((resolve, reject) => {
    API.post("API", "/id", {
      response: false,
      body: values
    }).then(response => {
      
      resolve(response);
    }).catch(error => {
      reject(error);
    })
  });
}

export const postUpload = (values) => {
  return new Promise((resolve, reject) => {
    API.post("API", "/upload", {
      response: false,
      body: values
    }).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    })
  });
}

export const postProfile = (values) => {
  return new Promise((resolve, reject) => {
    API.post("API", "/profile", {
      response: false,
      body: values
    }).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    })
  });
}
